import { useEffect } from 'react';

/**
 * The hook fires on outside click
 * @param {A reference to the parent element} ref
 * @param {A callback method} onClick
 */
const useOutside = (ref, onClick) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (onClick) onClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClick]);
};

export default useOutside;
